const color = {
  namespaced: true,
  state: {
    isShow: false,
    top: 0,
    left: 0,
    right: 0,
    position: 'absolute',
    color_change: Function,
    select_color: '', // 纯色的值
    Pattern: '', // pure_color 纯色   linear_gradient 渐变
    linear_gradient: {},
    edit_item_changed: false,
    selection_changed: false
  },
  mutations: {
    isShow_change(state, val) {
      state.isShow = val
    },
    select_color_change(state, val) {
      state.select_color = val
    },
    set_color_change(state, Fn) {
      state.color_change = Fn
    },
    set_Pattern(state, val) {
      state.Pattern = val
    },
    set_linear_gradient(state, val) {
      state.linear_gradient = val
    },
    set_position(state, obj) {
      state.top = obj.top
      state.left = obj.left
      state.right = obj.right
      state.position = obj.position
    },
    change_edit_item(state, data) {
      state.edit_item_changed = data
    },
    set_selection_changed(state, val) {
      state.selection_changed = val
    }
  },
  actions: {
  }
}
export default color
